// components/resources/featured-post.tsx

import type { PostPreview } from "@/types";

interface Props {
  post: PostPreview;
  tag?: string;
  readMore: string;
}

/**
 * Featured post temporarily disabled.
 * Returns null; no unused imports; TS-safe with "importsNotUsedAsValues": "error".
 */
export const ResourcesFeaturedPost = (_props: Props) => null;

/* ---------------- QUICK RESTORE (replace the export above with this block) ---------------

import React from "react";
import { Link } from "../link";
import { Image } from "../image";
import { AnimatePresence, motion } from "framer-motion";

export const ResourcesFeaturedPost: React.FC<Props> = ({ post, tag, readMore }) => {
  const formatDate = (date: string) => {
    const d = new Date(date);
    const month = d.toLocaleString("default", { month: "long" });
    const day = d.getDate();
    return `${month} ${day}`;
  };

  return (
    <div className="resourcesFeaturedPost">
      <AnimatePresence>
        <Link
          href={`/resources/${post.group}/${post.slug}`}
          noStyle
          className="resourcesFeaturedPost--link"
        >
          <div className="wrapper">
            <div className="resourcesFeaturedPost--text">
              <motion.div
                className="resourcesFeaturedPost--info"
                initial={{ y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 10, opacity: 0 }}
                transition={{ duration: 0.9, delay: 0, ease: [0.17, 0.55, 0.55, 1] }}
              >
                {tag && <div className="resourcesFeaturedPost--tag">{tag}</div>}
                <div className="resourcesFeaturedPost--date">{formatDate(post.date)}</div>
                {post.label && <div className="resourcesFeaturedPost--type">{post.label}</div>}
              </motion.div>

              <motion.h2
                className="resourcesFeaturedPost--title"
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 20, opacity: 0 }}
                transition={{ duration: 0.9, delay: 0.2, ease: [0.17, 0.55, 0.55, 1] }}
              >
                {post.title}
              </motion.h2>

              <motion.p
                className="resourcesFeaturedPost--description"
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 20, opacity: 0 }}
                transition={{ duration: 0.9, delay: 0.3, ease: [0.17, 0.55, 0.55, 1] }}
              >
                {post.description}
              </motion.p>

              <motion.div
                className="resourcesFeaturedPost--cta"
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 20, opacity: 0 }}
                transition={{ duration: 0.9, delay: 0.4, ease: [0.17, 0.55, 0.55, 1] }}
              >
                <span>{readMore}</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.0007 3.33331L8.82565 4.50831L13.4757 9.16665H3.33398V10.8333H13.4757L8.82565 15.4916L10.0007 16.6666L16.6673 9.99998L10.0007 3.33331Z"
                    fill="#2F323A"
                  />
                </svg>
              </motion.div>
            </div>
          </div>

          <motion.div
            className="wrapper wrapper_lg"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.9, delay: 0.3, ease: [0.17, 0.55, 0.55, 1] }}
          >
            {(post as any).coverImage?.file?.url && (
              <Image
                src={post.coverImage}
                alt={(post as any).coverImage?.title || post.title}
                width={(post as any).coverImage?.file?.details?.image?.width}
                className="resourcesFeaturedPost--image"
                animateInView
              />
            )}
          </motion.div>
        </Link>
      </AnimatePresence>
    </div>
  );
};

------------------------------------------------------------------------------------------- */
